














































































import StatsUtil from '@/util/StatsUtil';
import {
  Vue, Component, PropSync,
} from 'vue-property-decorator';

@Component({
  components: {},
})
export default class MarketOverview extends Vue {
  @PropSync('marketItems', {}) marketItemsSync!: [];

  @PropSync('marketSelected', {}) marketSelect!: any;

  @PropSync('loading', {}) loadingSync!: any;

  private headers = [

    {
      text: 'Market Name',
      align: 'left',
      value: 'name',
      width: '180px',
    },
    {
      text: 'Units',
      align: 'left',
      value: 'units',
      width: '100px',
      class: 'unit-tag',

    },
    {
      text: 'Restaurant Partner',
      align: 'left',
      value: 'partners',
      width: '176px',
      class: 'restaurentpartner-tag',
    },
    {
      text: 'Newly Onboarded',
      align: 'left',
      value: 'newlyOnBoarded',
      width: '176px',
    },
  ];

  public seeList: boolean = true;

  public onClickSee() {
    this.seeList = false;
  }
}
